import React from 'react';
import { DashboardSkeleton, ClientsSkeleton, BookingsSkeleton, CertificatesSkeleton } from './SkeletonLoader';

interface ContextualLoaderProps {
  view?: string;
  className?: string;
}

export const ContextualLoader: React.FC<ContextualLoaderProps> = ({ view, className = '' }) => {
  // Show specialized skeleton based on the view being loaded
  switch (view) {
    case 'dashboard':
      return <DashboardSkeleton />;
    case 'clients':
      return <ClientsSkeleton />;
    case 'bookings':
      return <BookingsSkeleton />;
    case 'certificates':
      return <CertificatesSkeleton />;
    default:
      return (
        <div className={`flex items-center justify-center min-h-96 ${className}`}>
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-emerald-500 mx-auto mb-4"></div>
            <p className="text-slate-600">Loading...</p>
          </div>
        </div>
      );
  }
};
